module.exports = __webpack_public_path__ + "static/media/white-logo.74fd8c72.svg";